enum NotificationType {
    GENERAL = "GENERAL",
    ALERT = "ALERT",
    NEW_COMMENT = "NEW_COMMENT",
    ATTACHMENT_DELIVERY_ISSUE = "ATTACHMENT_DELIVERY_ISSUE"
}

export default NotificationType;